











































































import { AutomatoFinitoNaoDeterministico } from "@/models/automato-finito-nao-deterministico";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import Transicoes from "@/components/Transicoes.vue";
import TesteCadeia from "@/components/TesteCadeia.vue";
import { Validation } from "@/interfaces/validation";
import AutomatoDeterministico from "./AutomatoDeterministico.vue";

@Component({
  components: {
    Transicoes,
    TesteCadeia
  }
})
export default class AutomatoNaoDeterministico extends Vue {
  @Prop({
    required: false,
    default: () => new AutomatoFinitoNaoDeterministico()
  })
  private afn!: AutomatoFinitoNaoDeterministico;
  @Prop({ required: false, default: "" }) private cadeia!: string;

  private get transicoesFormatadas(): string[] {
    return this.afn.transicoes.map(
      x => `${x[0]}, ${x[1]} -> {${Array.from(x[2]).join(", ")}}`
    );
  }

  private formatarSet(set: Set<string>): string {
    return Array.from(set).join(", ");
  }

  private validationClass(validacao: Validation): string {
    return validacao.valid ? "is-success" : "is-danger";
  }

  private converter(): void {
    this.$buefy.modal.open({
      parent: this,
      component: AutomatoDeterministico,
      props: {
        afd: this.afn.converterParaDeterministico(),
        cadeia: this.cadeia
      }
    });
  }
}
